export type TypeStepUpAsk = (fields: Readonly<Record<string, string>>) => Promise<boolean>;

let asker: TypeStepUpAsk | null = null;

let pending: Promise<boolean> | null = null;

export const stepUpHandler = {
    register: (next: TypeStepUpAsk): (() => void) => {
        asker = next;
        return () => { if (asker === next) asker = null; };
    },
    ask: (fields: Readonly<Record<string, string>>): Promise<boolean> => {
        if (asker === null) return Promise.resolve(false);
        if (pending === null) {
            pending = asker(fields).finally(() => { pending = null; });
        }
        return pending;
    },
};

export default stepUpHandler;
